<template>
  <v-toolbar-items>
    <v-menu
      v-model="dropdownCompany"
      :min-width="isMobileDevice ? 320 : 372"
      :close-on-click="false"
      :close-on-content-click="false"
      offset-y
      :left="!isMobileDevice"
      :right="isMobileDevice"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" text>
          <v-icon color="gray-6">location_city</v-icon>
          <span v-if="selectedCompany" class="d-none d-sm-flex d-xs-flex">
            {{ selectedCompany.name | ellipsis(25) }}
          </span>
          <span v-else class="ml-1 d-none d-sm-flex d-xs-flex">
            {{ $t(`${namespace}.allCompanies`) }}
          </span>
          <v-icon color="gray-6" right small>keyboard_arrow_down</v-icon>
        </v-btn>
      </template>

      <v-list v-if="dropdownCompany" class="dropdown__menu py-0">
        <v-list-item class="px-0">
          <v-list-item-title>
            <AutoCompleteCompany
              :company="selectedCompany"
              @resetCompany="handleClearSelectedCompany"
              @change="closeDropdownCompany"
            />
          </v-list-item-title>
        </v-list-item>

        <v-divider />

        <v-list-item @click="handleClearSelectedCompany">
          <v-list-item-title>{{ $t(`${namespace}.allCompanies`) }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getClosestElement } from 'corp-front-vue-commons/src/utils/functions'
import mediaQueries from 'mixins/mediaQueries'
import AutoCompleteCompany from 'components/AutoCompleteCompany'

export default {
  name: 'CompanyDropdownMenu',
  mixins: [mediaQueries],
  components: {
    AutoCompleteCompany
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isMobileDevice () {
      return this.isMobile || this.isTablet
    }
  },
  data () {
    return {
      namespace: 'Components.CompanyDropdownMenu',
      dropdownCompany: false
    }
  },
  methods: {
    ...mapActions({
      clearSelectedCompany: 'company/clearSelectedCompany'
    }),

    closeDropdownCompany () {
      this.dropdownCompany = false
    },

    openDropdownCompany () {
      this.dropdownCompany = true
    },

    handleClearSelectedCompany () {
      this.clearSelectedCompany()
      setTimeout(() => this.closeDropdownCompany(), 50)
    },

    dropdownCompanyToogle (e) {
      const parent = getClosestElement(e.target, '.dropdown__menu')
      const cls = e.target.classList

      if (cls.contains('v-list-item')) return
      if (parent) {
        return this.openDropdownCompany()
      }

      this.closeDropdownCompany()
    }
  },
  mounted () {
    document.addEventListener('click', this.dropdownCompanyToogle, false)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.dropdownCompanyToogle)
  }
}
</script>
